import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';

@Injectable({
  providedIn: 'root'
})

export class OigService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  uploadLEIE(param: FormData): Observable<any> {
    let URL = 'api/Employee/ImportLeie'

    return this.http.post(URL, param, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getMatchedEmployee(params: URLSearchParams): Observable<any> {
    let url = 'api/Employee/GetLEIEMatchedEmployees?'
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
